import React from "react";
import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/style.css";

const PhoneForm = ({ formik }) => {
  return (
    <>
      <PhoneInput
        country="us"
        value={formik.getFieldProps("phoneNumber").value}
        onChange={(phone) => formik.setFieldValue("phoneNumber", phone)}
      />
      {formik.touched.phoneNumber && formik.errors.phoneNumber && (
        <div className="fv-help-block">{formik.errors.phoneNumber}</div>
      )}
    </>
  );
};

export default PhoneForm;
